<template>
  <header class="app-header navbar" id="app-header">
    <div class="col-md-3 header-left-image">
      <b-link class="navbar-brand"></b-link>
    </div>
  </header>
</template>
<script>
export default {
  name: 'c-login-header',
  props: {
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    };
  }
};
</script>

<style lang="less">
@import '~@/styles/variables.less';

@media screen and (max-width: 610px) {
  .col-md-6 {
    width: 260px;
  }
}

.header-left-image {
  width: auto;
  min-width: 103px;
}

.app-header.navbar .navbar-brand {
  width: 135px;
  height: 69px;
  padding: unset;
  margin-right: unset;
  border-bottom: none;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// LoginHeader.vue?62a4a252